
import Badge from "../components/Badge.vue";
import Event from "../components/InteractiveComponents/Event.vue";
import Section from "../components/Section.vue";
import { mapState } from "vuex";
import { getProvinceWithCode, getProvinces } from "../utils/staticData";
import { isMobile } from "../utils/common";
import { vietnameseTextToSlug } from "../utils/common";

export default {
  layout: "root",
  components: { Event, Section, Badge },
  computed: {
    ...mapState("Event", [
      "listEvent",
      "eventLoading",
      "newestEventData",
      "metadata",
      "newestEventLoading",
    ]),
  },
  asyncData(context) {
    let userAgent = "";
    if (process.server) {
      const { req } = context;
      userAgent = req.headers["user-agent"];
    }
    return {
      mobile: isMobile(userAgent),
    };
  },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      provinceId: "all",
      mobile: null,
      provinces: getProvinces("array"),
      baseImageURL: this.$config.BASE_URL_RESOURCE,
    };
  },
  mounted() {
    this.getListEvent({});
    this.$store.dispatch("Event/getListNewestEvent", { location: "" });
  },
  methods: {
    getFirstPTag(desc = "") {
      if (!process.client) return "";

      const div = document.createElement("div");
      div.innerHTML = desc.replaceAll("&nbsp;", " ");

      const firstP = div.querySelector("p");

      if (firstP) return firstP.innerText;

      // fallback nếu không có p
      return div.textContent.split("\n")[0];
    },
    getPath(title, id) {
      console.log(title, id);
      return vietnameseTextToSlug(title, id);
    },
    getListEvent({
      filter_by = "",
      page_size = 6,
      current_page = 1,
      sort_by = "id",
      order = "desc",
      newList = true,
    }) {
      this.$store.dispatch("Event/getListEvent", {
        filter_by,
        page_size,
        page: current_page,
        sort_by,
        order,
        newList,
      });
    },
    getMoreEvent() {
      this.getListEvent({
        ...this.metadata,
        current_page: this.metadata.current_page + 1,
        newList: false,
      });
    },
    generateImageURL(params) {
      if (Array.isArray(params)) {
        return this.BASE_URL_STATIC + params[0];
      } else {
        return this.BASE_URL_STATIC + params;
      }
    },
    handleFilter(code) {
      this.provinceId = code;
      if (code === "all") {
        this.getListEvent({});
      } else {
        const { name } = getProvinceWithCode(code);
        if (name) {
          this.getListEvent({ filter_by: name });
        }
      }
    },
  },
};
